import { UserApplicationComment } from "@/api/lctApISchemas";
import { useUserAppInfo } from "@/hooks/useUserAppInfo";

interface IProps {
  userAppId: string;
  comment?: UserApplicationComment;
}

export const CarbonScore: React.FC<IProps> = ({ userAppId, comment }) => {
  const { carbonScore } = useUserAppInfo(userAppId);
  return (
    <section className={`rounded-lg bg-primary p-4`}>
      <div className="my-1 flex flex-col">
        <span className="text-sm font-normal text-white">Carbon Score</span>
        <span className="text-2xl font-medium text-white">{carbonScore ?? 0}</span>
      </div>
      <span className="text-sm font-normal text-white">{comment?.comment_text}</span>
    </section>
  );
};
